export { TabItemRenderer } from './component';
export {
  StyledActionButton,
  StyledTabActions,
  StyledTabHeader,
  StyledTabItem,
  StyledTabTitle,
  StyledToggleWrapper,
} from './styled';
export type { StyledTabItemProps, TabItemRendererProps } from './types';
